import React from "react";
import {Link} from "react-router-dom";
import LogoUrl from '../../assets/img/logo.svg';

const ComponentError = ({error, resetErrorBoundary}) => {
    return <>

        <main>
            <div className="site-content site-content--error">
                <div className="text-center">
                    <div className="container container-sm">
                        <Link to={"/"}><img src={LogoUrl} /></Link>
                        <h1>Something went wrong</h1>
                        <p>Unfortunately, an error occurred while loading the page. You can try refreshing the page in your browser or checking your internet connection. If the problem persists, please return to the homepage or contact our support.</p>
                        <Link to="/" className={"button button-outline"}><i className="fal fa-arrow-rotate-right"></i> Reload page</Link>
                    </div>
                </div>
            </div>
        </main>
    </>
}

export default ComponentError;
